// /assets/scripts/events/event-bus.js
export const EventBus = {
  events: {},

  on(event, callback) {
    if (!this.events[event]) this.events[event] = [];
    this.events[event].push(callback);
    return () => this.off(event, callback); // unsubscribe
  },

  off(event, callback) {
    if (!this.events[event]) return;
    this.events[event] = this.events[event].filter(cb => cb !== callback);
  },

  once(event, callback) {
    const onceWrapper = (...args) => {
      callback(...args);
      this.off(event, onceWrapper);
    };
    this.on(event, onceWrapper);
  },

  emit(event, data) {
    if (this.events[event]) {
      this.events[event].forEach(cb => cb(data));
    }
    // Support for wildcard listeners (e.g., open.*)
    const [prefix] = event.split('.');
    const wildcardKey = `${prefix}.*`;
    if (this.events[wildcardKey]) {
      this.events[wildcardKey].forEach(cb => cb(data));
    }
  }
};
